import { formatCop } from "./formatUtils";

/**
 * Los valores monetarios del módulo Proyectos vienen del backend en **pesos COP** (long).
 * (El primer brief decía "centavos", pero los valores reales —SMMLV 1750905, factorJornal 81153,
 * precioReferencial 150000— son claramente pesos.) `CENTAVOS_POR_PESO` es el único punto a tocar:
 * si en runtime resultara que sí son centavos, ponerlo en 100.
 */
export const CENTAVOS_POR_PESO = 1;

export function centavosAPesos(centavos: number): number {
  return (Number(centavos) || 0) / CENTAVOS_POR_PESO;
}

/** "$1.423.500" a partir de centavos. */
export function fmtCentavos(centavos: number): string {
  return "$" + formatCop(centavosAPesos(centavos));
}

/** Porcentaje desde decimal (0.065 → "6.5%"). A prueba de NaN/undefined → "0.0%". */
export function fmtPct(decimal: number, decimals = 1): string {
  const n = Number(decimal);
  return (Number.isFinite(n) ? n * 100 : 0).toFixed(decimals) + "%";
}

/** Timestamp Unix ms o ISO → fecha corta es-CO. */
export function fmtFechaProy(v: number | string | null): string {
  if (v == null || v === "") return "—";
  const ms = typeof v === "number" ? v : (/^\d+$/.test(v) ? Number(v) : Date.parse(v));
  if (isNaN(ms)) return "—";
  return new Date(ms).toLocaleDateString("es-CO", { year: "numeric", month: "short", day: "2-digit" });
}

/** Tiempo relativo en es-CO ("hace 3 días", "hace 2 meses"). Fechas futuras → "hoy". */
export function fmtHace(v: number | string | null): string {
  if (v == null || v === "") return "—";
  const ms = typeof v === "number" ? v : (/^\d+$/.test(v) ? Number(v) : Date.parse(v));
  if (isNaN(ms)) return "—";
  const dias = Math.floor((Date.now() - ms) / 86_400_000);
  if (dias <= 0) return "hoy";
  if (dias === 1) return "hace 1 día";
  if (dias < 30) return `hace ${dias} días`;
  const meses = Math.floor(dias / 30);
  if (meses === 1) return "hace 1 mes";
  if (meses < 12) return `hace ${meses} meses`;
  const años = Math.floor(dias / 365);
  return años === 1 ? "hace 1 año" : `hace ${años} años`;
}
